// extracted by mini-css-extract-plugin
module.exports = {"root":"_5d645c","cta":"_ee83eb","button":"_e41639","container":"_1e7f6e","compareBtn":"_e5d77c"};